var exports = {
  "v_": "DiscoveryNavbar.module__navbar___Um1fak",
  "Bx": "DiscoveryNavbar.module__leftSection___Um1fak",
  "LY": "DiscoveryNavbar.module__leftSurface___Um1fak",
  "Gv": "DiscoveryNavbar.module__backButton___Um1fak",
  "dc": "DiscoveryNavbar.module__searchTitle___Um1fak",
  "$L": "DiscoveryNavbar.module__categoryTabs___Um1fak",
  "Wu": "DiscoveryNavbar.module__categoryTab___Um1fak",
  "KB": "DiscoveryNavbar.module__categoryTabActive___Um1fak" + " " + "DiscoveryNavbar.module__categoryTab___Um1fak",
  "uk": "DiscoveryNavbar.module__searchArea___Um1fak",
  "rm": "DiscoveryNavbar.module__searchForm___Um1fak",
  "qc": "DiscoveryNavbar.module__searchIcon___Um1fak",
  "Rt": "DiscoveryNavbar.module__searchInput___Um1fak",
};

module.exports = exports;
